/* TPW cart drawer, pay-later panel (cart redesign "One Line", Nov 2026). House code, no library. Hardware store only:
   snippets/cart-drawer.liquid links this file inside its store_mode tpw branch.
   The line under Checkout (button[data-tpw-pl-open]) opens dialog[data-tpw-pl] (snippets/tpw-paylater-sheet, ids renamed so the PDP's
   own #v7-pl-sheet is never duplicated). Both nodes are re-rendered with the drawer footer on every quantity change, remove and add,
   so nothing here binds to them: one set of document listeners, nodes looked up at the moment they are needed.
   - Esc closes ONLY the panel. cart.js closes the drawer on a document-level capture keydown (and on keyup at <cart-drawer>), so while
     the panel is open those two events are stopped at the window (stopPropagation, never preventDefault: the browser's own dialog
     close still runs). The Esc that closes the panel is also swallowed on keyup, because by then focus is back inside the drawer.
   - Tab inside the panel is left to the browser (a modal dialog traps it); cart.js's own Tab trap must not move focus meanwhile.
   - Closing returns focus to the line (the node is looked up fresh, so a re-render in between does not lose it).
   - A click on the backdrop closes it; if the drawer itself is closed (or the cart goes empty) while it is open, the panel closes too.
   - No animation anywhere. */
(function () {
  "use strict";
  if (window.__tpwDrawerPl) return;
  window.__tpwDrawerPl = true;

  var SHEET = "cart-drawer dialog[data-tpw-pl]";
  var OPENER = "cart-drawer [data-tpw-pl-open]";
  var swallowKeyup = false;
  var watcher = null;

  function sheet() { return document.querySelector(SHEET); }
  function isOpen() { var d = sheet(); return !!(d && d.open); }

  function stopWatch() {
    if (watcher) { watcher.disconnect(); watcher = null; }
  }
  function watchDrawer() {
    stopWatch();
    var drawer = document.querySelector("cart-drawer");
    if (!drawer || !window.MutationObserver) return;
    watcher = new MutationObserver(function () {
      var d = sheet();
      if (!d || !d.open) { stopWatch(); return; }
      if (!drawer.classList.contains("active")) d.close();
    });
    watcher.observe(drawer, { attributes: true, attributeFilter: ["class"] });
  }

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest(OPENER)) {
      var d = sheet();
      if (d && !d.open && typeof d.showModal === "function") {
        e.preventDefault();
        d.showModal();
        watchDrawer();
      }
      return;
    }
    // backdrop: the dialog is the event target when the click lands outside its box (its own padding also reports the dialog)
    if (t.matches && t.matches(SHEET) && t.open) {
      var r = t.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) t.close();
    }
  });

  // "close" does not bubble; the capture phase still sees it
  document.addEventListener("close", function (e) {
    var d = e.target;
    if (!d || !d.matches || !d.matches(SHEET)) return;
    stopWatch();
    var drawer = document.querySelector("cart-drawer");
    if (!drawer || !drawer.classList.contains("active")) return;
    var o = document.querySelector(OPENER);
    if (o) { try { o.focus({ preventScroll: true }); } catch (err) { o.focus(); } }
  }, true);

  window.addEventListener("keydown", function (e) {
    if (!isOpen()) return;
    if (e.key === "Escape") swallowKeyup = true;
    if (e.key === "Escape" || e.key === "Tab") e.stopPropagation();
  }, true);
  window.addEventListener("keyup", function (e) {
    if (e.key !== "Escape" || !swallowKeyup) return;
    swallowKeyup = false;
    e.stopPropagation();
  }, true);
})();
